import React from 'react';

import styles from './ErrorText.module.scss';

const ErrorText = ({ children }: React.PropsWithChildren) => (
  <p className={styles.ErrorText}>{children}</p>
);

export default ErrorText;
